import React from 'react';
import {
  Typography,
  TextField,
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

import ReportBuilder from './ReportBuilder';

const styles = {
  paper: {
    // margin: 20,
    margin: 2,
    // padding: 10,
    padding: 1,
  },
  container: {
    // padding: 10,
    padding: 1,
  },
  text: {
    display: 'block',
    // marginBottom: 10,
    marginBottom: 1,
  },
  gridItem: {
    flex: 1,
  },
  recommendation: {
    // paddingBottom: 10,
    paddingBottom: 1,
  },
};

function wellSortFunc(a, b) {
  if (parseInt(a.ASSET_ID) < parseInt(b.ASSET_ID)) return -1;
  if (parseInt(b.ASSET_ID) < parseInt(a.ASSET_ID)) return 1;
  return -1;
}

class Permit extends React.Component {
  state = {
    diameter: '?',
    reportYear: '?',
    reportPumpage: '?',
    allocationBeginYear: '?',
    allocationEndYear: '?',
    allocation: '?',
  };

  componentDidMount = async () => {
    console.log('componentDidMount');
    const diameter = await ReportBuilder.getDiameter(this.props.permit);
    // const wellNo = ReportBuilder.getLeadWellNumber(this.props.permit);
    // const year = ReportBuilder.getReportYear(this.props.permit.DATE_CREATED);
    const { reportYear, pumpage } = await ReportBuilder.getAnnualReportPumpage(
      this.props.permit
    );
    console.log('diameter:');
    console.log(diameter);
    console.log('pumpage:');
    console.log(pumpage);

    const { termBegin, termEnd, allocation } =
      await ReportBuilder.getAllocationAmount(this.props.permit);
    console.log('termBegin:', termBegin);
    console.log('termEnd:', termEnd);
    console.log('allocation:', allocation);

    this.setState({
      diameter,
      reportYear,
      reportPumpage: pumpage,
      allocationBeginYear: termBegin
        ? new Date(termBegin).getUTCFullYear()
        : '?',
      allocationEndYear: termEnd ? new Date(termEnd).getUTCFullYear() : '?',
      allocation,
    });
  };

  render() {
    const { permit, classes } = this.props;
    console.log('PermitDetails: props:');
    console.log(this.props);
    return (
      <Grid
        container
        direction='column'
        /*spacing={5}*/
        sx={styles.container}
      >
        <Grid item>
          <Paper sx={styles.paper}>
            <TextField
              variant='standard'
              label='Case Number'
              defaultValue={permit.CASE_NUMBER}
              inputProps={{
                readOnly: true,
                style: { minWidth: 350 },
              }}
              multiline
            />
          </Paper>
        </Grid>
        <Grid item>
          <Paper sx={styles.paper}>
            <Grid container direction='row'>
              <Grid item sx={styles.gridItem}>
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="Lead Well"*/
                  helperText='Lead Well'
                  defaultValue={ReportBuilder.getLeadWellNumber(permit)}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="District Plan Compliance"*/
                  helperText='District Plan Compliance'
                  defaultValue={ReportBuilder.getDistrictPlanCompliance(permit)}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="District Plan Compliance"*/
                  helperText='New Permit Term'
                  defaultValue={ReportBuilder.getTerm(permit)}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
              </Grid>
              <Grid item sx={styles.gridItem}>
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="Reg. Area"*/
                  helperText='Reg. Area'
                  defaultValue={ReportBuilder.getRegArea(permit)}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label={`${year - 2} Annual Report Pumpage`}*/
                  helperText={
                    this.state.reportYear && this.state.reportYear !== '?'
                      ? `${this.state.reportYear} Annual Report Pumpage`
                      : 'Annual Report Pumpage'
                  }
                  // defaultValue={`${this.state.reportPumpage} MG`}
                  value={
                    // this.state.reportPumpage !== null &&
                    // this.state.reportPumpage >= 0 &&
                    // this.state.reportPumpage !== '?'
                    typeof this.state.reportPumpage === 'number'
                      ? `${Number(this.state.reportPumpage).toFixed(2)} MG`
                      : 'NA'
                  }
                  // value={`${Number(this.state.reportPumpage).toFixed(2)} MG`}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="District Plan Compliance"*/
                  helperText='Expiring Permit Term'
                  defaultValue={ReportBuilder.getExpiringTerm(permit)}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item>
          <Paper sx={styles.paper}>
            <Grid container direction='row'>
              <Grid item sx={styles.gridItem}>
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="Prev. 12 mos. Groundwater"*/
                  helperText='Prev. 12 mos. Groundwater'
                  defaultValue={`${Number(
                    ReportBuilder.getPrev12MGroundwater(permit)
                  ).toFixed(2)} MG`}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="Prev. 12 mos. Alternate Water"*/
                  helperText='Prev. 12 mos. Alternate Water'
                  defaultValue={`${Number(
                    ReportBuilder.getPrev12MAlternateWater(permit)
                  ).toFixed(2)} MG`}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label="Prev. 12 mos. Total Water Demand"*/
                  helperText='Prev. 12 mos. Total Water Demand'
                  defaultValue={`${Number(
                    ReportBuilder.getPrev12MGroundwater(permit) +
                      ReportBuilder.getPrev12MAlternateWater(permit)
                  ).toFixed(2)} MG`}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
              </Grid>
              <Grid item sx={styles.gridItem}>
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label={`${year - 1} Allocation`}*/
                  // helperText={`${ReportBuilder.getYear(permit) - 1} Allocation`}
                  helperText={`${
                    this.state.allocationBeginYear === '?'
                      ? 'Previous'
                      : `${this.state.allocationBeginYear}-${this.state.allocationEndYear}`
                  } Permit Allocation`}
                  // defaultValue={`${Number(this.state.allocation).toFixed(
                  //   2
                  // )} MG`}
                  // defaultValue={
                  //   this.state.allocation
                  //   // typeof this.state.allocation === 'number'
                  //   //   ? `${Number(this.state.allocation).toFixed(2)} MG`
                  //   //   : 'N/A'
                  // }
                  value={
                    typeof this.state.allocation === 'number'
                      ? `${Number(this.state.allocation).toFixed(2)} MG`
                      : 'NA'
                  }
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label={`${year} Request`}*/
                  // helperText={`${ReportBuilder.getYear(permit)} Request`}
                  helperText={`${ReportBuilder.getTermBeginYear(
                    permit
                  )} Request`}
                  defaultValue={`${Number(
                    ReportBuilder.getRequestedAmount(permit)
                  ).toFixed(2)} MG`}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
                <TextField
                  variant='standard'
                  sx={styles.text}
                  /*label={`${year} Recommendation`}*/
                  helperText={`${ReportBuilder.getTermBeginYear(
                    permit
                  )} Recommendation`}
                  defaultValue={`${Number(
                    ReportBuilder.getRecommendationAmount(permit)
                  ).toFixed(2)} MG`}
                  inputProps={{ readOnly: true, style: { minWidth: 350 } }}
                  multiline
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item>
          <Paper sx={styles.paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Well</TableCell>
                  <TableCell>Term</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>Diameter</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {permit.wells.sort(wellSortFunc).map((w) => (
                  <TableRow key={w.ASSET_ID}>
                    <TableCell>{w.ASSET_ID}</TableCell>
                    <TableCell>{ReportBuilder.getTerm(permit)}</TableCell>
                    <TableCell>
                      <Typography
                        variant='body2'
                        style={{ whiteSpace: 'pre-line' }}
                      >
                        {w.LOCATION}
                      </Typography>
                    </TableCell>
                    <TableCell>{`${w.diameter}"`}</TableCell>
                    <TableCell>{ReportBuilder.getStatus(permit)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        <Grid item>
          <Paper sx={styles.paper}>
            <Typography variant='h5' gutterBottom>
              Recommendations
            </Typography>
            {ReportBuilder.getRecommendations(permit).map((note, key) => (
              <Typography key={key} variant='body1' sx={styles.recommendation}>
                {`${key + 1}) ${note}`}
              </Typography>
            ))}
          </Paper>
        </Grid>
        <Grid item>
          <Paper sx={styles.paper}>
            <Typography variant='h5' gutterBottom>
              Testimony and Findings
            </Typography>
            {ReportBuilder.getTestimony(permit).map((note, key) => (
              <Typography key={key} variant='body1' sx={styles.recommendation}>
                {note}
              </Typography>
            ))}
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default Permit;
